var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0938 0H16.9062C7.84533 0 0.5 7.34533 0.5 16.4062V53.5938C0.5 62.6547 7.84533 70 16.9062 70H54.0938C63.1547 70 70.5 62.6547 70.5 53.5938V16.4062C70.5 7.34533 63.1547 0 54.0938 0Z",
    fill: "#242938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5003 40.182C38.3178 40.182 40.6015 37.898 40.6015 35.0807C40.6015 32.2635 38.3178 29.9795 35.5003 29.9795C32.683 29.9795 30.399 32.2635 30.399 35.0807C30.399 37.898 32.683 40.182 35.5003 40.182Z",
    fill: "#00D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5005 24.7087C42.3496 24.7087 48.7122 25.6915 53.5097 27.3433C59.2899 29.3331 62.8438 32.3494 62.8438 35.0808C62.8438 37.927 59.0774 41.1314 52.8701 43.1879C48.1774 44.7427 42.0021 45.5543 35.5005 45.5543C28.8347 45.5543 22.5224 44.7925 17.7766 43.1707C11.7725 41.1185 8.15625 37.8728 8.15625 35.0808C8.15625 32.3716 11.5496 29.3785 17.2486 27.3917C22.0638 25.7128 28.5834 24.7087 35.4995 24.7087H35.5005Z",
    stroke: "#00D8FF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4714 29.9244C29.8932 23.9914 33.9228 18.9705 37.7504 15.6401C42.3616 11.6268 46.7503 10.0551 49.1161 11.4193C51.5817 12.8412 52.4761 17.7051 51.1568 24.1095C50.1601 28.9513 47.7773 34.706 44.5292 40.3383C41.199 46.1128 37.3859 51.2003 33.6106 54.5002C28.8333 58.6761 24.2147 60.1874 21.7961 58.7926C19.4492 57.4402 18.5518 53.0048 19.6778 47.0753C20.6291 42.0651 23.0165 35.9157 26.4703 29.9244H26.4714Z",
    stroke: "#00D8FF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4798 40.3534C23.0485 34.4269 20.7122 28.4271 19.7372 23.4478C18.5633 17.4484 19.3932 12.8614 21.757 11.4932C24.2204 10.0669 28.8806 11.7212 33.7702 16.0628C37.4671 19.3452 41.2632 24.2827 44.5207 29.9094C47.8605 35.6784 50.3635 41.5232 51.3372 46.4417C52.5693 52.6663 51.5721 57.4222 49.1557 58.8208C46.8113 60.1782 42.5208 58.7412 37.9459 54.8043C34.0806 51.4782 29.9451 46.3389 26.4798 40.3534Z",
    stroke: "#00D8FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactIcon);
export default __webpack_public_path__ + "static/media/reactIcon.6faf68b01f8f3a7d8364bc7792049421.svg";
export { ForwardRef as ReactComponent };